import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { FwdRollOrderDataImpl } from "../model/impl/FwdRollOrderDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class FwdRollOrderDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: FwdRollOrderDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.fixingDts != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.fixingDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingCd != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.fixingCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveDts != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(5),
        false,
        encodable.lastSaveDts,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveUserCode != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(6),
        false,
        encodable.lastSaveUserCode,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.lastSaveUserId != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.lastSaveUserId,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.portfolioId != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.portfolioId,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.orders != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        true,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(13),
        false,
        encodable.orders,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        FwdRollOrderDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,FwdRollOrderDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.util.Date"],
    [4, "java.lang.String"],
    [5, "java.util.Date"],
    [6, "java.lang.String"],
    [7, "java.lang.Long"],
    [8, "java.lang.String"],
    [9, "java.lang.String"],
    [13, "com.bcdfx.model.event.lifecycle.fx.OrderData"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: FwdRollOrderDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.fixingDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.fixingCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.moment.Moment = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.lastSaveDts = <CubiqTS.moment.Moment>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.lastSaveUserCode = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.lastSaveUserId = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.portfolioId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: Array<CubiqTS.OrderData> = this.baseEncoder.readObject(
            false,
            true,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.orders = <Array<CubiqTS.OrderData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            FwdRollOrderDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,FwdRollOrderDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return FwdRollOrderDataImplEncoder.fidTypeMap.has(fid);
  }
}
